module.exports = __webpack_public_path__ + "static/img/1961_Originale_Kontakte_Cologne_4.d4af165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1961_Originale_Kontakte_Cologne_4.jpg
// module id = 6RIJ
// module chunks = 0